module.exports = __webpack_public_path__ + "static/DTT_Icone_Localisation-ef075bbf723512d89427d79c84da127e.svg";